import { LightningElement } from "lwc";

export type BooleanAttr = boolean | string | null;

export function attrToBool<T>(attr: T) {
  if (typeof attr === "boolean") {
    return attr;
  }
  if (typeof attr === "string") {
    return attr === "true" || attr === "";
  }
  return !!attr;
}

export function attrToNumber<T>(attr: T) {
  return Number(attr);
}

export function waitForPageSettled() {
  return new Promise((resolve) => {
    let prevH: number = 0;
    let prevY = window.scrollY;
    function check() {
      let nextH = window.innerHeight + document.body.scrollHeight;
      let nextY = window.scrollY;
      let settled = nextH === prevH;
      if (settled) {
        if (nextY === prevY) resolve(void 0);
        return;
      }
      prevH = nextH;
      requestAnimationFrame(check);
    }
    requestAnimationFrame(check);
  });
}

export abstract class ChildrenElement<T> extends LightningElement {
  private observer!: MutationObserver;

  items: T[] = [];

  abstract childTagName: string;
  abstract extractor: (element: Element) => T;

  connectedCallback() {
    this.observer = new MutationObserver(() => {
      this.setItems();
    });
    this.observer.observe(this.template.host, {
      childList: true,
      subtree: true,
    });
    this.setItems();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  setItems() {
    this.items = Array.from(this.template.host.children)
      .filter((n) => n.tagName === this.childTagName)
      .map(this.extractor);
  }
}
